import React from 'react';
import T from 'prop-types';
import { isNil } from 'lodash-es';

const PercentageChange = ({ value }) => {
  if (isNil(value)) return '- %';

  const perc = Math.round(value * 1000) / 10;
  let direction = '';
  let content = '- %';

  if (value !== 0) {
    if (perc === 0) {
      content = '0.0%';
    } else {
      direction = perc > 0 ? 'text-green' : 'text-rose';
      content = `${perc > 0 ? '+' : '-'}${Math.abs(perc).toFixed(1)}%`;
    }
  }

  return (
    <div className="percentage-change">
      <div className={direction}>{content}</div>
    </div>
  );
};

PercentageChange.propTypes = {
  value: T.number,
};

export default PercentageChange;
